import React, { FC, MouseEvent, RefObject, useState } from "react";
import { darkTheme } from "@yleisradio/yds-core";
import { VolumeOff } from "@yleisradio/yds-icons-react";
import styled from "styled-components";

import { useEmbedParametersContext } from "../../contexts/EmbedParametersContext";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import { videoPreviewBackgroundColor } from "../../styles/variables";

const MuteButtonStyled = styled.button<{
  buttonVisible: boolean;
  muted: boolean;
}>`
  align-items: center;
  background: ${videoPreviewBackgroundColor};
  border: none;
  border-radius: 20px;
  color: ${darkTheme.ACTION_PRIMARY};
  display: flex;
  height: 40px;
  justify-content: center;
  opacity: ${props => (props.buttonVisible && props.muted ? "1" : "0")};
  padding: 8px;
  position: absolute;
  right: 8px;
  top: 8px;
  transition:
    opacity 1s,
    visibility 2s;
  visibility: ${props =>
    props.buttonVisible && props.muted ? "visible" : "hidden"};
  width: 40px;
  z-index: 9;
`;

interface Props {
  controlsVisible: boolean;
  ref: RefObject<HTMLButtonElement | null>;
}

export const UnmuteButton: FC<Props> = ({ controlsVisible, ref }) => {
  const { useStoreState } = usePlayerStore();
  const device = useStoreState.device();
  const isMuted = useStoreState.isMuted();
  const player = useStoreState.player();

  const [buttonVisible, setButtonVisible] = useState(true);

  const { language, unmuteButton } = useEmbedParametersContext();

  const unMute = (event: MouseEvent) => {
    /*
     * To prevent player UI getting focus (and revealing the controls) in
     * all cases on iPhoneOS Safari, this needs to:
     *
     * 1) be onMouseDown (at least onTouchStart does not work)
     * 2) have event.preventDefault()
     */
    event.preventDefault();
    event.stopPropagation();
    player.setMuted(false, true);
    setButtonVisible(false);
  };

  if (unmuteButton && device.isMobile && !controlsVisible) {
    return (
      <MuteButtonStyled
        aria-label={i18n("poista_mykistys_aria_label", { language })}
        ref={ref}
        onMouseDown={unMute}
        {...{ buttonVisible, muted: isMuted }}>
        <VolumeOff />
      </MuteButtonStyled>
    );
  } else {
    return null;
  }
};
